import React from 'react';
import {BrowserRouter,Routes,Route} from 'react-router-dom';
import './App.css';
import BigFiveForm from './components/pages/BigFiveForm.js';

// Only the assessment is in the main bundle; the other pages load when first visited (IMP-088)
const AuthPage = React.lazy(() => import('./components/pages/AuthPage.js'));
const CreateProfile = React.lazy(() => import('./components/pages/CreateProfile.js'));
const Matching = React.lazy(() => import('./components/pages/Matching.js'));
const MyMatches = React.lazy(() => import('./components/pages/MyMatches.js'));
const Search = React.lazy(() => import('./components/pages/Search.js'));
const ProfileView = React.lazy(() => import('./components/pages/ProfileView.js'));
const Team = React.lazy(() => import('./components/pages/Team.js'));

function App() {
  return (
    <BrowserRouter>
      <React.Suspense fallback={<div className="App--route-loading" aria-busy="true"></div>}>
      <Routes>
        <Route path="/" element={<BigFiveForm/>}/>
        <Route path="/form" element={<BigFiveForm/>}/>
        <Route path="/login" element={<AuthPage/>}/>
        <Route path="/createprofile" element={<CreateProfile/>}/>
        <Route path="/matching" element={<Matching/>}/>
        <Route path="/mymatches" element={<MyMatches/>}/>
        <Route path="/search" element={<Search/>}/>
        <Route path="/profile/:id" element={<ProfileView/>}/>
        <Route path="/team" element={<Team/>}/>
      </Routes>
      </React.Suspense>
    </BrowserRouter>
  );
  /*
  Use Link for UI components
  Use navigate for redirection as a result of functions
  */
}

export default App;
